import { NextPageContext } from "next";

import { withPropsSerialization } from "src/utilities/ssr/withPropsSerialization";
import { withServerSideTestingProps } from "src/utilities/ssr/withServerSideTestingProps";

type EdoServerSideProps = {
  [key: string]: any;
  props?: { [key: string]: any };
};

type EdoServerSidePropsHandler = (
  ctx: NextPageContext
) => Promise<EdoServerSideProps>;

type EdoWithServerSidePropsWrapper = (
  handler: EdoServerSidePropsHandler
) => EdoServerSidePropsHandler;

/**
 * Chains multiple "withServerSideX" functions, allowing them to wrap a base GSSP handler.

 * The wrappers are applied from left to right:
 * `chainServerSideProps(baseHandler, wrapper1, wrapper2)` is equivalent to
 * `wrapper2(wrapper1(baseHandler))`.
 */
function chainServerSideProps(
  baseHandler: EdoServerSidePropsHandler,
  ...wrappers: EdoWithServerSidePropsWrapper[]
): EdoServerSidePropsHandler {
  return wrappers.reduce((acc, wrap) => wrap(acc), baseHandler);
}

const GSSP_WRAPPERS: EdoWithServerSidePropsWrapper[] = [
  withServerSideTestingProps,
  withPropsSerialization,
];

/**
 * Creates a GSSP handler that applies the default wrappers to the base handler.
 * This is useful for creating a GSSP handler that has the same behavior as the
 * default GSSP handlers in the app.
 */
export function createGetServerSideProps(
  baseHandler: EdoServerSidePropsHandler
): EdoServerSidePropsHandler {
  return chainServerSideProps(baseHandler, ...GSSP_WRAPPERS);
}
